import {observer} from "mobx-react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../react-hooks/use-services.hook";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import {AccordionComponent} from "../../accordion/accordion.component";
import {OptInJackpotBetDialogBox} from "../boxes/opt-in-jackpot-bet-dialog/opt-in-jackpot-bet-dialog.box";
import {OptInAccordionContentComponent} from "./components/opt-in-accordion-content/opt-in-accordion-content.component";
import {OptInDialogHeaderComponent} from "./components/opt-in-dialog-header/opt-in-dialog-header.component";
import {OptInAccordionTitleComponent} from "./opt-in-accordion-title/opt-in-accordion-title.component";

export interface IOptInJackpotBetDialogOptions {
    dialogHandler: IModalDialogHandler;
}
export const OptInJackpotBetDialogComponent: React.FC<IOptInJackpotBetDialogOptions> = observer((props) => {
    const services = useServices();
    const close = () => {
        services.jackpotBet.toggleJackpotBet();
        props.dialogHandler.close();
    }
    return (
        <OptInJackpotBetDialogBox>
            <OptInDialogHeaderComponent dialogHandler={props.dialogHandler} />
            <div style={{padding: "2rem"}}>
                <AccordionComponent
                    title={<OptInAccordionTitleComponent />}
                    content={<OptInAccordionContentComponent />}
                    isTitleCentered={true}
                />
                <Button
                    preset="primary"
                    margin="0px 0px 2rem 0px"
                    fullWidth
                    className={'cy-opt-in-jackpot-bet-button'}
                >
                    {services.translation.translate('JOIN_JACKPOT_BET')}
                </Button>
                <Button
                    preset="secondary"
                    margin="0px 0px 2rem 0px"
                    fullWidth
                    className={'cy-opt-out-jackpot-bet-button'}
                    onClick={close}
                >
                    {services.translation.translate('PLAY_WITHOUT_JACKPOT_BET')}
                </Button>

            </div>
        </OptInJackpotBetDialogBox>
    )
})